Ext.define('SA.data.CensusReleaseId', {
    constructor({countryCode, censusReleaseYear}) {
        this.stringValue = `${countryCode}-${censusReleaseYear}`;
    },

    equals(otherId) {
        return this.toString() === otherId.toString();
    },

    toString() {
        return this.stringValue;
    }
});